import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    VDR_DATA_USER,
    VDR_DOCUMENT_TYPE,
    VDR_DELIVERY_ORDER,
    VDR_SUPPLIER,
    VDR_EQUIPMENT,
    VDR_SERIAL,
    VDR_STATUS_REVIEW,
    VDR_USER_REVIEW,
    VDR_UNIT_HEALTH,
    VDR_LIST,
    VDR_VALIDATE,
    VDR_CHECKLIST_VALIDATION,
    VDR_STATUS_DOCS,
    VDR_SEE_VALIDATE,
} from "../../actions";

import {
    VDRDataUserSuccess,
    VDRDataUserError,
    VDRDocumentTypeSuccess,
    VDRDocumentTypeError,
    VDRDeliveryOrderSuccess,
    VDRDeliveryOrderError,
    VDRSupplierSuccess,
    VDRSupplierError,
    VDREquipmentSuccess,
    VDREquipmentError,
    VDRSerialSuccess,
    VDRSerialError,
    VDRStatusReviewSuccess,
    VDRStatusReviewError,
    VDRUserReviewSuccess,
    VDRUserReviewError,
    VDRStatusDocsSuccess,
    VDRStatusDocsError,
    VDRUnitHealthSuccess,
    VDRUnitHealthError,
    VDRListSuccess,
    VDRListError,
    VDRValidateSuccess,
    VDRValidateError,
    VDRChecklistValidationSuccess,
    VDRChecklistValidationError,
    VDRSeeValidateSuccess,
    VDRSeeValidateError,
} from '../../actions';

export function* watchVDRDataUser() {
    yield takeEvery(VDR_DATA_USER, onVDRDataUser);
}

export function* watchVDRDocumentType() {
    yield takeEvery(VDR_DOCUMENT_TYPE, onVDRDocumentType);
}

export function* watchVDRDeliveryOrder() {
    yield takeEvery(VDR_DELIVERY_ORDER, onVDRDeliveryOrder);
}

export function* watchVDRSupplier() {
    yield takeEvery(VDR_SUPPLIER, onVDRSupplier);
}

export function* watchVDREquipment() {
    yield takeEvery(VDR_EQUIPMENT, onVDREquipment);
}

export function* watchVDRSerial() {
    yield takeEvery(VDR_SERIAL, onVDRSerial);
}

export function* watchVDRStatusReview() {
    yield takeEvery(VDR_STATUS_REVIEW, onVDRStatusReview);
}

export function* watchVDRUserReview() {
    yield takeEvery(VDR_USER_REVIEW, onVDRUserReview);
}

export function* watchVDRStatusDocs() {
    yield takeEvery(VDR_STATUS_DOCS, onVDRStatusDocs);
}

export function* watchVDRUnitHealth() {
    yield takeEvery(VDR_UNIT_HEALTH, onVDRUnitHealth);
}

export function* watchVDRList() {
    yield takeEvery(VDR_LIST, onVDRList);
}

export function* watchVDRValidate() {
    yield takeEvery(VDR_VALIDATE, onVDRValidate);
}

export function* watchVDRChecklistValidation() {
    yield takeEvery(VDR_CHECKLIST_VALIDATION, onVDRChecklistValidation);
}

export function* watchVDRSeeValidate() {
    yield takeEvery(VDR_SEE_VALIDATE, onVDRSeeValidate);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onVDRDataUserAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/user', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRDocumentTypeAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/documenttype', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRDeliveryOrderAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/deliveryorder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRSupplierAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDREquipmentAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/equipment', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRSerialAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/serial', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRStatusReviewAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/statusreview', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRUserReviewAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/userreview', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRStatusDocsAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/statusdocs', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRUnitHealthAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/unithealth', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'validationDocumentReview/documentreviewlist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRValidateAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'validationDocumentReview/validate', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRChecklistValidationAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/checklistvalidation', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onVDRSeeValidateAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'validationDocumentReview/seevalidate', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onVDRDataUser(data) {
    try {
        const response = yield call(onVDRDataUserAsync, data.payload);
        yield put(VDRDataUserSuccess(response.data));
    } catch (error) {
        yield put(VDRDataUserError(error));
    }
}

function* onVDRDocumentType(data) {
    try {
        const response = yield call(onVDRDocumentTypeAsync, data.payload);
        yield put(VDRDocumentTypeSuccess(response.data));
    } catch (error) {
        yield put(VDRDocumentTypeError(error));
    }
}

function* onVDRDeliveryOrder(data) {
    try {
        const response = yield call(onVDRDeliveryOrderAsync, data.payload);
        yield put(VDRDeliveryOrderSuccess(response.data));
    } catch (error) {
        yield put(VDRDeliveryOrderError(error));
    }
}

function* onVDRSupplier(data) {
    try {
        const response = yield call(onVDRSupplierAsync, data.payload);
        yield put(VDRSupplierSuccess(response.data));
    } catch (error) {
        yield put(VDRSupplierError(error));
    }
}

function* onVDREquipment(data) {
    try {
        const response = yield call(onVDREquipmentAsync, data.payload);
        yield put(VDREquipmentSuccess(response.data));
    } catch (error) {
        yield put(VDREquipmentError(error));
    }
}

function* onVDRSerial(data) {
    try {
        const response = yield call(onVDRSerialAsync, data.payload);
        yield put(VDRSerialSuccess(response.data));
    } catch (error) {
        yield put(VDRSerialError(error));
    }
}

function* onVDRStatusReview(data) {
    try {
        const response = yield call(onVDRStatusReviewAsync, data.payload);
        yield put(VDRStatusReviewSuccess(response.data));
    } catch (error) {
        yield put(VDRStatusReviewError(error));
    }
}

function* onVDRUserReview(data) {
    try {
        const response = yield call(onVDRUserReviewAsync, data.payload);
        yield put(VDRUserReviewSuccess(response.data));
    } catch (error) {
        yield put(VDRUserReviewError(error));
    }
}

function* onVDRStatusDocs(data) {
    try {
        const response = yield call(onVDRStatusDocsAsync, data.payload);
        yield put(VDRStatusDocsSuccess(response.data));
    } catch (error) {
        yield put(VDRStatusDocsError(error));
    }
}

function* onVDRUnitHealth(data) {
    try {
        const response = yield call(onVDRUnitHealthAsync, data.payload);
        yield put(VDRUnitHealthSuccess(response.data));
    } catch (error) {
        yield put(VDRUnitHealthError(error));
    }
}

function* onVDRList(data) {
    try {
        const response = yield call(onVDRListAsync, data.payload);
        yield put(VDRListSuccess(response.data));
    } catch (error) {
        yield put(VDRListError(error));
    }
}

function* onVDRValidate(data) {
    try {
        const response = yield call(onVDRValidateAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(VDRValidateSuccess(response.data));
    } catch (error) {
        yield put(VDRValidateError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onVDRChecklistValidation(data) {
    try {
        const response = yield call(onVDRChecklistValidationAsync, data.payload);
        yield put(VDRChecklistValidationSuccess(response.data));
    } catch (error) {
        yield put(VDRChecklistValidationError(error));
    }
}

function* onVDRSeeValidate(data) {
    try {
        const response = yield call(onVDRSeeValidateAsync, data.payload);
        yield put(VDRSeeValidateSuccess(response.data));
    } catch (error) {
        yield put(VDRSeeValidateError(error));
    }
}


export default function* rootSaga() {
    yield all([
        fork(watchVDRDataUser),
        fork(watchVDRDocumentType),
        fork(watchVDRDeliveryOrder),
        fork(watchVDRSupplier),
        fork(watchVDREquipment),
        fork(watchVDRSerial),
        fork(watchVDRStatusReview),
        fork(watchVDRUserReview),
        fork(watchVDRStatusDocs),
        fork(watchVDRUnitHealth),
        fork(watchVDRList),
        fork(watchVDRValidate),
        fork(watchVDRChecklistValidation),
        fork(watchVDRSeeValidate)
    ]);
}